import _mixin from '../_mixin'

export default {
  name: 'SVersionKV',
  cnName: 'KV头图',
  type: 'activity_version',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/ec1b37e3c6ecc9cb624e4849f456b6e5.jpg',
      style: {
        width: '1920px',
        height: '1080px'
      }
    },
    btnReturn: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/11/e98d40eadb649f59dacf14b44ccd355e.png',
      style: {
        width: '193px',
        height: '50px',
        top: '39px',
        right: '43px',
        bottom: '',
        left: ''
      }
    },
    btnReturnLink: 'https://www.ssjj.cn/',
    btnDownLoad: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/11/43ca1a16353b065ec3ca42a65f2deef8.png',
      style: {
        width: '452px',
        height: '125px',
        top: '',
        right: '734px',
        bottom: '50px',
        left: ''
      }
    },
    pointMark: 'xxxDownload'
  },
  propsDesc: [
    {
      target: 'defaultBg',
      label: 'kv图',
      formType: 'image'
    },
    /* 返回按钮配置 */
    {
      target: 'btnReturn',
      label: '返回按钮图片',
      formType: 'image'
    },
    {
      target: 'btnReturnLink',
      label: '返回按钮转链'
    },
    /* 下载按钮配置 */
    {
      target: 'btnDownLoad',
      label: '下载按钮图片',
      formType: 'image'
    },
    {
      target: 'pointMark',
      label: '埋点标识'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
